import { motion } from "framer-motion";
import LeadForm from "./LeadForm";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="px-6 sm:px-10 lg:px-16 py-24 lg:py-32">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#555] mb-6">One flat fee. One decision.</p>
          <h2 className="font-display font-semibold tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
            STOP SPLITTING<br />
            YOUR <span className="text-[#FF3B30]">COMMISSION.</span>
          </h2>
          <p className="mt-6 max-w-md text-base sm:text-lg text-[#555] leading-relaxed">
            Tell us where to send your personalised breakdown. $250/month, no lock-in, and a team that runs everything from listing to settlement.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5"
        >
          <div className="bg-[#111111] text-[#F9F8F6] p-6 sm:p-8" data-testid="final-form-card">
            <p className="text-sm font-semibold mb-5">Get your full breakdown</p>
            <LeadForm source="footer" testIdPrefix="final" dark />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
